import { EntityStatus } from '../../../core/interfaces/entity-status';
import { Enum } from '../../../core/interfaces/object-enum';


export class TargetStatusEnum extends Enum {
  static OK = new EntityStatus('Active', 'OK', 'success');
  static FAILED = new EntityStatus('Failed', 'FAILED', 'error');
}
